import React from 'react';
import './Thoughts.css';

const Thoughts = () => {
  return (
    <section id="thoughts" className="thoughts-section">
      <div className="thoughts-content">
        <h2>Thoughts</h2>
        <p>
          I believe software has the power to reshape the way we live. Over the past 20-25 years, we've witnessed its transformative potential — but this is just the beginning with AI world. The impact of softwares in our lives is yet to unfold.
        </p>
      </div>
    </section>
  );
};

export default Thoughts; 